import React from 'react';
import { DevsuLogoIcon } from './DevsuLogoIcon';
import { DevsuLogoText } from './DevsuLogoText';

interface DevsuLogoCompleteProps {
  // Both width and height are required together to pin an exact pixel box;
  // omit both to size via `className` (e.g. a height utility + `aspect-[107/25]`).
  width?: number;
  height?: number;
  className?: string;
}

// Inset percentages measured from the source Figma SVG's bounding boxes (viewBox 107x25).
export const DevsuLogoComplete: React.FC<DevsuLogoCompleteProps> = ({
  width,
  height,
  className = '',
}) => {
  const hasFixedSize = width !== undefined && height !== undefined;
  return (
    <div
      className={`relative shrink-0 ${className}`}
      style={hasFixedSize ? { width, height } : undefined}
    >
      <div className="absolute inset-y-0 left-0 right-[77.628%]">
        <DevsuLogoIcon className="block h-full w-auto" />
      </div>
      <div className="absolute bottom-[13.943%] left-[28.022%] right-0 top-[10.162%]">
        <DevsuLogoText className="block h-full w-auto" />
      </div>
    </div>
  );
};
